import { observer } from 'mobx-react';
import React from 'react';

import Async from 'components/Async';
import GoBackHeader from 'components/Page/GoBackHeader';

import { StyledPageContentWrapper } from './styled';
import { PropsType } from './types';

function PageContent({ title, onGoBack, children, isLoading, ...props }: PropsType) {
	return (
		<StyledPageContentWrapper {...props}>
			<Async loading={isLoading}>
				<GoBackHeader title={title} onGoBack={onGoBack} />
				{children}
			</Async>
		</StyledPageContentWrapper>
	);
}

export default observer(PageContent);
